import { AbstractPowerVesselize } from '@vesselize/core';
export * from '@vesselize/core';
import { inject } from 'vue';

const INJECT_KEY = Symbol('vesselize');
const VUEX_KEY = 'vesselize';

function createVesselize(options) {
    return new VueVesselize(options);
}
class VueVesselize extends AbstractPowerVesselize {
    constructor(options) {
        const { key, ...vesselizeOptions } = options;
        super(vesselizeOptions);
        this.injectKey = key;
    }
    install(app) {
        app.provide(this.injectKey || INJECT_KEY, this);
    }
    createVuexPlugin(key = VUEX_KEY) {
        return (store) => {
            store[key] = this;
        };
    }
}

function useVesselize(key = INJECT_KEY) {
    return inject(key);
}
function useProvider(provide) {
    const vesselize = useVesselize();
    return vesselize.getProvider(provide);
}
function useInstance(provide, context) {
    const vesselize = useVesselize();
    if (context) {
        return vesselize.getInContext(provide, context);
    }
    else {
        return vesselize.get(provide);
    }
}
function useAsyncInstance(provide, context) {
    const vesselize = useVesselize();
    if (context) {
        return vesselize.getInContextAsync(provide, context);
    }
    else {
        return vesselize.getAsync(provide);
    }
}

export { VueVesselize, createVesselize, useAsyncInstance, useInstance, useProvider, useVesselize };
